import { ErrorDialogComponent, ErrorDialogData, } from "@app/components/error-dialog/error-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Inject, Injectable } from "@angular/core";
import { APP_CONSTANTS } from "@app/constants";

@Injectable({
    providedIn: 'root'
})
export class ErrorDialogService {
    constructor(@Inject(MatDialog) private dialog: MatDialog) { }

    showError(
        title: string,
        message: string,
        contactInfo?: typeof APP_CONSTANTS.CONTACT_INFO) {

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: APP_CONSTANTS.ERROR_DIALOG_WIDTH,
            data: {
                title: title,
                message: message,
                contactInfo: contactInfo
            } as ErrorDialogData,
            disableClose: true,
        });
        return dialogRef.afterClosed();
    }
}
